import { locale } from '@/utils/locale';

export const TitanUpgradeToastHandlerLocale = {
  knowMore: locale('titanAdvertisement.toast.knowMore'),
  description: locale('titanAdvertisement.toast.description'),
  yourDomain: locale('titanAdvertisement.toast.yourDomain'),
  title: locale('titanAdvertisement.toast.title'),
  newTag: locale('titanAdvertisement.toast.newTag'),
};
